<template>
  <div class="" v-resize="onResize">
    <h1 class="py-6">
      {{ $t("goods.writeoffs")
      }}<v-btn
        color="success"
        class="ml-1 green-shadow"
        x-small
        fab
        max-width="26"
        max-height="26"
        :loading="!fetched || nowProcessingItemWithId !== null"
        :disabled="!fetched || nowProcessingItemWithId !== null"
        @click="
          goodsMovementForm.id = null;
          goodsMovementForm.isVisible = true;
        "
        :title="$t('common.add')"
      >
        <v-icon x-small>$plus</v-icon>
      </v-btn>
    </h1>

      <v-row class="mx-0 w-100 mb-5">
        <v-col xs="6" md="4" class="pa-0 mx-0">
          <v-card class="pa-3 ma-0" elevation="0">
            <v-text-field
                outlined
                :placeholder="$t('goods.start_typing_last_name_or_company')"
                :label="$t('common.search')"
                append-outer-icon="fa-times"
                hide-details
                @click:append-outer="search=''"
                v-model="search"
                class="mb-2"
            ></v-text-field>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        ref="goodsIncomingTable"
        :headers="goodsWriteoffTableHeader"
        :items="goods_writeoff"
        class="elevation-0 mb-3 w-100"
        :loading="!fetched"
        :disabled="!fetched"
        @update:options="(options)=>{setTableOptions(options);getGoodsWriteoffs()}"
        :server-items-length="itemsTotalCount"
        :options="tableOptions"
        :height="tableHeight"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
      >
        <template v-slot:footer.page-text="props">
          {{
            $t("tables.x_of_y", [
              `${props.pageStart}-${props.pageStop}`,
              props.itemsLength,
            ])
          }}
        </template>
        <template v-slot:[lastHeaderElement]="props">
          {{ props.header.text }}
          <table-config-btn :table="tableName" :default-columns="defaultGoodsWriteoffTableHeader"/>
        </template>
        <template v-slot:item.supplier="props">
          {{props.item.supplier && (props.item.supplier.full_name || props.item.supplier.name)}}
        </template>
        <template v-slot:item.date="props">
          {{props.item.date | moment("DD.MM.YYYY")}}
        </template>
        <template v-slot:item.status="props">
          <goods-movement-basis-status :item="props.item"/>
        </template>
        <template v-slot:item.goods_movement_document_type.name="props">
          <span v-if="props.item.goods_movement_document_type">
            {{
              $t(
                "movementDocumentTypes.full." +
                  props.item.goods_movement_document_type.name
              )
            }}
          </span>
        </template>
        <template v-slot:item.actions="props">
          <span class="btn-td-wrap">
            <v-btn
              elevation="0"
              @click="
                goodsMovementForm.id = props.item.id;
                goodsMovementForm.isVisible = true;
              "
              min-width="36"
              min-height="36"
              color="primary"
              class="mb-0 ml-3 px-0 white--text"
              :title="$t('common.edit')"
            >
              <v-icon small>$pencil</v-icon>
            </v-btn>
          </span>
        </template>
        <template v-slot:no-data>
          {{ $t("common.no_data_available") }}
        </template>
        <template v-slot:no-results>
          {{ $t("common.no_data_available") }}
        </template>
      </v-data-table>

    <goods-movement-form
      :id="goodsMovementForm.id"
      :show="goodsMovementForm.isVisible"
      @hide="
        goodsMovementForm.isVisible = false;
        goodsMovementForm.id = null;
      "
      type="goods_writeoff"
    />

  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import GoodsMovementForm from "@/components/storage/GoodsMovementForm";
import GoodsMovementBasisStatus from "../../components/storage/GoodsMovementBasisStatus";
import CommonMixin from "@/mixins/common";
import TableConfigBtn from "@/components/common/TableConfigBtn";

export default {
  components: {TableConfigBtn, GoodsMovementBasisStatus, GoodsMovementForm },
  mixins: [CommonMixin],
  data: () => ({
    searchTimeoutId: null,
    tableName: "goods_writeoffs",
    goodsMovementForm: {
      isVisible: false,
      id: null,
    },
    tableHeight: "100",
  }),
  created() {},
  methods: {
    get(){
      this.$store.dispatch("goods_movement_bases/get", {
        type: "goods_writeoff",
      });
    },
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["goodsIncomingTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
    setTableOptions(options) {
      this.tableOptions = options;
    },
    getGoodsWriteoffs(){
      this.$store.dispatch("tables_config/get").then(()=> {
        this.get();
      });
    }
  },
  watch:{
    search(to, from) {
      if (to.length >= 3 || to.length === 0) {
        clearTimeout(this.searchTimeoutId);
        this.searchTimeoutId = setTimeout(() => {
          this.get();
        }, 1100);
      }
    },
  },
  computed: {
    ...mapFields("goods_movement_bases", [
      "nowProcessingItemWithId",
      "goods_writeoff",
      "tableOptions",
      "itemsTotalCount",
      "search",
      "fetched",
    ]),
    lastHeaderElement(){
      return 'header.'+(this.goodsWriteoffTableHeader.slice(-1) && this.goodsWriteoffTableHeader.slice(-1)[0] && this.goodsWriteoffTableHeader.slice(-1)[0].value);
    },
    goodsWriteoffTableHeader() {
      let tableHeaderConfig =  this.getConfiguredTableHeader(this.tableName, this.defaultGoodsWriteoffTableHeader);
      return tableHeaderConfig.filter(item=>item.is_hidden!==true)
    },
    defaultGoodsWriteoffTableHeader() {
      return [
        {
          text: "#",
          value: "human_number",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("goods.goods_movement_document_type"),
          value: "goods_movement_document_type.name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.status"),
          value: "status",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.date"),
          value: "date",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.order"),
          value: "order.human_number",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.customer"),
          value: "supplier",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.responsible"),
          value: "responsible_for.name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.created_by"),
          value: "created_by_user.name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          width: "150px",
          text: "",
          sortable: false,
          class: "text-no-wrap flex-nowrap justify-space-between",
          is_action_column: true,
          value: "actions"
        },
      ];
    },
  },
};
</script>

<style></style>
